
/*
 * VNCcontact+ : A new level of contact management
 * Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, version 3 of the License.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. Look for COPYING file in the top folder.
 * If not, see http://www.gnu.org/licenses/.
 */

import { Injectable } from "@angular/core";


@Injectable()
export class LocalStorageService {
    constructor() {
    }

    getItem(key: string): any {
        return localStorage.getItem(key);
    }

    setItem(key: string, data: string): void {
        localStorage.setItem(key, data);
    }

    removeItem(key: string): void {
        localStorage.removeItem(key);
    }
}


@Injectable()
export class DummyStorageService {
    private storage: any;

    constructor() {
        this.storage = {};
    }

    getItem(key: string): any {
        return this.storage[key];
    }

    setItem(key: string, data: string): void {
        this.storage[key] = data;
    }

    removeItem(key: string): void {
        delete this.storage[key];
    }
}
